// extracted by mini-css-extract-plugin
module.exports = {"selectSimple":"select-simple-64b"};